<template>
    <section class="zemlya-calendar">
        <a class="zemlya-calendar__link" href="/auctions/calendar/">
            <h3 class="zemlya-calendar__link-title">Календарь торгов федеральной недвижимости</h3>
            <svg class="zemlya-calendar__link-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.7925 18.3641C14.1831 18.7546 14.8162 18.7546 15.2067 18.3641L20.8636 12.7072C21.2541 12.3167 21.2541 11.6835 20.8636 11.293L15.2067 5.63616C14.8162 5.24563 14.1831 5.24563 13.7925 5.63616C13.402 6.02668 13.402 6.65984 13.7925 7.05037L17.7423 11.0001L3.84277 11.0001C3.29049 11.0001 2.84277 11.4478 2.84277 12.0001C2.84277 12.5524 3.29049 13.0001 3.84277 13.0001L17.7423 13.0001L13.7925 16.9499C13.402 17.3404 13.402 17.9736 13.7925 18.3641Z" fill="#252628"/>
            </svg>
        </a>
        <div class="zemlya-calendar__swiper">
            <button 
                @click="slidePrev"
                class="zemlya-calendar__swiper-button prev"
                :class="{'disabled': isBeginning}"
                :disabled="isBeginning"
            >   
                <svg   xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <rect width="40" height="40" rx="20" transform="matrix(-1 0 0 1 40 0)" fill="#252628"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2067 20.4801C13.9311 20.215 13.9311 19.785 14.2067 19.5199L18.699 15.1989C18.9746 14.9337 19.4216 14.9337 19.6972 15.1989C19.9729 15.464 19.9729 15.8939 19.6972 16.1591L16.41 19.321H25.2941C25.684 19.321 26 19.625 26 20C26 20.375 25.684 20.679 25.2941 20.679H16.41L19.6972 23.8409C19.9729 24.1061 19.9729 24.536 19.6972 24.8011C19.4216 25.0663 18.9746 25.0663 18.699 24.8011L14.2067 20.4801Z" fill="white"/>
                </svg>
            </button>
            
            <swiper
                :slides-per-view="19"
                :space-between="12"
                @swiper="onSwiper"
                @slideChange = "onSlideChange"
                :breakpoints="{
                    320: { slidesPerView: 5.8, spaceBetween: 8 },
                    540: { slidesPerView: 6 },
                    630: { slidesPerView: 7 },
                    685: { slidesPerView: 8 },
                    740: { slidesPerView: 9 },
                    830: { slidesPerView: 10 },
                    910: { slidesPerView: 11 },
                    1000: { slidesPerView: 12, spaceBetween: 12 },
                    1080: { slidesPerView: 13 },
                    1170: { slidesPerView: 14 },
                    1250: { slidesPerView: 15 },
                    1330: { slidesPerView: 16 },
                    1410: { slidesPerView: 17 },
                    1470: { slidesPerView: 18 },
                    1520: { slidesPerView: 19 },
                }"
            >
                <swiper-slide v-for="(day, index) in visibleDays" :key="'calendar' + index">
                    <a 
                        class="zemlya-calendar__day" 
                        :class="{ 'current-day': isToday(day.date)}"
                        :href="'/auctions/calendar/?date-from=' + formatDate(day.date) + '&date-to=' + formatDate(day.date)"
                    >
                        <div class="zemlya-calendar__day-info">
                            <p class="zemlya-calendar__day-number">{{ day.dayNumber }}</p>
                            <p class="zemlya-calendar__day-name">{{ day.dayName }}</p>
                        </div>
                        
                        <div class="zemlya-calendar__day-markers">
                            <div 
                                v-if="day.events.includes('start')"
                                class="zemlya-calendar__day-marker start"
                            >
                            </div>
                            <div
                                v-if="day.events.includes('ending')"
                                class="zemlya-calendar__day-marker ending"
                            >
                            </div>
                        </div>
                    </a>
                </swiper-slide>
            </swiper>
            <button
                @click="slideNext"
                class="zemlya-calendar__swiper-button next"
                :class="{'disabled': isEnd}"
                :disabled="isEnd"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <rect width="40" height="40" rx="20" fill="#252628"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M25.7933 20.4801C26.0689 20.215 26.0689 19.785 25.7933 19.5199L21.301 15.1989C21.0254 14.9337 20.5784 14.9337 20.3028 15.1989C20.0271 15.464 20.0271 15.8939 20.3028 16.1591L23.59 19.321H14.7059C14.316 19.321 14 19.625 14 20C14 20.375 14.316 20.679 14.7059 20.679H23.59L20.3028 23.8409C20.0271 24.1061 20.0271 24.536 20.3028 24.8011C20.5784 25.0663 21.0254 25.0663 21.301 24.8011L25.7933 20.4801Z" fill="white"/>
                </svg>
            </button>
            
        </div>
        <div class="zemlya-calendar__container">
            <p class="zemlya-calendar__months">{{ displayedMonths }}</p>
            <div class="zemlya-calendar__description">
                <div class="zemlya-calendar__description-block">
                    <div class="zemlya-calendar__description-circle green"></div>
                    <p class="zemlya-calendar__description-text">Проведение торгов</p>
                </div>
                <div class="zemlya-calendar__description-block">
                    <div class="zemlya-calendar__description-circle blue"></div>
                    <p class="zemlya-calendar__description-text">Окончание приема заявок</p>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { ref, computed, onMounted, defineProps, watch } from "vue";
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css'

export default {
	name: 'ZemlyaCalendar',
    props: ['calendar-info'],
}
</script>

<script setup>
const props = defineProps(['calendar-info']);
const calendarInfo = props.calendarInfo;

const today = new Date();
const swiperInstance = ref(null);
const days = ref([]);

const isBeginning = ref(true)
const isEnd = ref(false)

const visibleDays = computed(() => days.value.filter(day => day.visible));

const activeMonths = ref([])

const monthNames = [
    'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
    'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
]

const displayedMonths = computed(() => {
    if (activeMonths.value.length === 0) return ''
    if (activeMonths.value.length === 1) return monthNames[activeMonths.value[0]]

    const [firstMonth, secondMonth] = activeMonths.value;
    return `${monthNames[firstMonth]} - ${monthNames[secondMonth]}`
})

onMounted(() => {
    prepareCalendarData();
    updateActiveMonths();
})

function onSwiper(swiper) {
    swiperInstance.value = swiper
    setTimeout(() => {
        updateActiveMonths();
    }, 100)
    
}

function updateNavigationState() {
    if (swiperInstance.value) {
        isBeginning.value = swiperInstance.value.isBeginning
        isEnd.value = swiperInstance.value.isEnd
    }
}

function isToday(date) {
    return formatDate(date) === formatDate(today)
}

function formatDate(date) {
    if(!date) return ''
    const d = new Date(date)
    return `${d.getDate().toString().padStart(2, '0')}.${(d.getMonth() + 1).toString().padStart(2, '0')}.${d.getFullYear()}`
}

function prepareCalendarData() {
    if (!calendarInfo || typeof calendarInfo !== 'object') return

    const eventsArray = Object.entries(calendarInfo).map(([key, value]) => {
        return {
            date: value.date,
            type: value.type
        }
    })

    const eventDates = eventsArray.map(event => {
        const [day, month, year] = event.date.split('.')
        return new Date(`${year}-${month}-${day}`)
    })

    if(eventDates.length == 0) return

    const minDate = new Date(Math.min(...eventDates))
    const maxDate = new Date(Math.max(...eventDates))

    const startDate = today > minDate ? today : minDate

    const daysArray = []
    let currentDate = new Date(startDate)

    while (currentDate <= maxDate) {
        const dateStr = formatDate(currentDate)
        const dayEvents = eventsArray
            .filter(event => event.date == dateStr)
            .map(event => event.type)

        daysArray.push({
            date: new Date(currentDate),
            dayNumber: currentDate.getDate(),
            dayName: getDayName(currentDate.getDay()),
            events: dayEvents,
            visible: true,
        })

        currentDate.setDate(currentDate.getDate() + 1)
    }

    days.value = daysArray
}

function getDayName(dayIndex) {
    const days = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб']
    return days[dayIndex]
}

function onSlideChange() {
    updateNavigationState()
    updateActiveMonths()
}

function updateActiveMonths() {
    if (!swiperInstance.value || visibleDays.value.length == 0) return
    const visibleMonths = new Set();
    const slidesPerView = swiperInstance.value.params.slidesPerView;
    const activeIndex = swiperInstance.value.activeIndex;

    for (let i = 0; i < slidesPerView && (activeIndex + i) < visibleDays.value.length; i++) {
        const day = visibleDays.value[activeIndex + i];
        if (day && day.date) {
            visibleMonths.add(day.date.getMonth());
        }
    }

    const monthsArray = Array.from(visibleMonths).sort((a, b) => a - b)
    if (monthsArray.length == 0) {
        activeMonths.value = [];
    } else if (monthsArray.length == 1) {
        activeMonths.value = [monthsArray[0]];
    } else {
        const firstMonth = monthsArray[0];
        const lastMonth = monthsArray[monthsArray.length - 1]

        if (lastMonth - firstMonth == monthsArray.length - 1) {
            activeMonths.value = [firstMonth, lastMonth];
        } else {
            activeMonths.value = [firstMonth, (firstMonth + 1) % 12];
        }
    }
}

function slidePrev() {
    if (swiperInstance.value && !isBeginning.value) {
        swiperInstance.value.slidePrev()
    }
}

function slideNext() {
    if (swiperInstance.value && !isEnd.value) {
        swiperInstance.value.slideNext();
    }
}

watch(visibleDays, () => {
    if (swiperInstance.value) {
        updateActiveMonths();
    }
}, { deep: true });
</script>